const sentence = (...parts: string[]) => parts.join(" ");

export const aboutTranslations = {
  about: {
    hero: {
      tagline: "قصتنا",
      title: "المكان الذي يجمع مختبري البرمجيات للنمو والتواصل وإيجاد فرص العمل",
      subtitle: sentence(
        "Quality Nexus مجتمع عالمي بناه مختبرون من أجل المختبرين. نساعد محترفي ضمان",
        "الجودة على مواكبة تغيرات السوق، وتحويل مهاراتهم إلى دخل، ونساعد الشركات على",
        "بناء فرق QA استثنائية.",
      ),
      primaryCta: "انضم إلى المجتمع",
      secondaryCta: "كن شريكًا",
      imageAlt: sentence(
        "فريق متنوع من مختبري البرمجيات يتعاونون",
        "حول أجهزتهم المحمولة",
      ),
    },
    story: {
      label: "لماذا وجد Quality Nexus",
      title: sentence(
        "رأينا السوق يتغير، فتحمّلنا المسؤولية لمساعدة المختبرين على النمو من خلال",
        "تعلم حقيقي",
      ),
      quote: "أفضل المختبرين لا يولدون — بل يتم تدريبهم وتواصلهم ودعمهم.",
      paragraph1: sentence(
        "بدأ Quality Nexus بملاحظة بسيطة: عالم الاختبار يتغير بسرعة، وعدد كبير من",
        "المختبرين يتنقلون فيه بمفردهم — يشترون دورات باهظة تعد بكل شيء وتعلّم القليل",
        "جدًا. خلال خروجة عفوية، حوّل مجموعة من أصدقاء QA هذا الإحباط إلى حوار، ومن",
        "هذا الحوار وُلدت المهمة.",
      ),
      paragraph2: sentence(
        "نؤمن أن تعلم QA لا يجب أن يكون محيرًا أو مكلفًا أو مدفوعًا بمبيعات فارغة.",
        "تخيلنا مساحة يمكن للمختبرين فيها التعلم بتوجيه حقيقي، والعثور على مرشدين",
        "موثوقين، ومشاركة التجارب الصادقة، والاحتفال بإنجازاتهم، وتحويل مهاراتهم إلى",
        "دخل حقيقي. مكان بناه مختبرون، من أجل المختبرين — ومن أجل الشركات التي",
        "تحتاجهم أيضًا.",
      ),
      paragraph3: sentence(
        "هذه الفكرة أصبحت Quality Nexus — منصة للأفراد والشركات على حد سواء. نمكّن",
        "المختبرين من التطور والربح، ونساعد الشركات على اكتشاف أفضل مواهب QA، ونقدم",
        "خدمات اختبار احترافية للشركات الناشئة التي لا تريد بناء فرق QA ضخمة من اليوم",
        "الأول.",
      ),
      imageAlt: "فريق اختبار برمجيات يراجع تقارير الجودة معًا",
    },
    ecosystem: {
      label: "ما ستجد داخل المنصة",
      title: "كل ما يحتاجه المختبر أو فريق QA للمضي قدمًا",
      subtitle: sentence(
        "نظام بيئي متكامل للتعلم والتواصل والتوظيف والاختبار — صُمم حول احتياجات",
        "مختبري البرمجيات والشركات التي تعتمد عليهم.",
      ),
      profiles: {
        title: "ملفات شخصية بارزة",
        description: sentence(
          "اعرض مهاراتك وشهاداتك ومشاريعك ليجدك أصحاب العمل والباحثون عن المواهب بشكل",
          "أسرع.",
        ),
      },
      feed: {
        title: "منشورات ومناقشات",
        description: sentence(
          "اطرح الأسئلة، وشارك التجارب الحقيقية، واحصل على نصائح صادقة من مجتمع عالمي",
          "من المختبرين الذين يفهمون العمل.",
        ),
      },
      learning: {
        title: "تعلم منظم",
        description: sentence(
          "وفر مقالات ودليلاً وفيديوهات وموارد عملية تبقيك على اطلاع بأدوات واتجاهات QA",
          "المهمة.",
        ),
      },
      mentorship: {
        title: "برنامج الإرشاد",
        description: sentence(
          "تواصل مع موجهين ذوي خبرة يساعدونك في التعامل مع تغيرات المسار المهني وثغرات",
          "المهارات وخطواتك التالية.",
        ),
      },
      study: {
        title: "مجموعات دراسة ومسارات",
        description: sentence(
          "تعلّم مع الزملاء من خلال مسارات منظمة وجلسات جماعية وتحديات عملية مبنية حول",
          "احتياجات السوق الحقيقية.",
        ),
      },
      jobs: {
        title: "وظائف وفرص",
        description: sentence(
          "اكتشف أدوار QA ومشاريع العمل الحر والإحالات التي تساعدك في تحويل خبرتك إلى",
          "دخل حقيقي.",
        ),
      },
      companies: {
        title: "مواهب للشركات",
        description: sentence(
          "ساعد الشركات في العثور على أفضل مختبري البرمجيات وتقييمهم وتوظيفهم مع تحسين",
          "تجربة QA داخل فرقها.",
        ),
      },
      services: {
        title: "خدمات الاختبار",
        description: sentence(
          "احصل على تدريب واستشارات وخدمات اختبار احترافية مصممة للفرق والمشاريع بكل",
          "أحجامها.",
        ),
      },
    },
    missionVision: {
      label: "الهدف",
      title: "لماذا نحن هنا",
      subtitle: sentence(
        "نؤمن أن الجودة ليست مجرد مرحلة في التطوير — بل هي عقلية وحرفة ومجتمع يرفع",
        "الجميع.",
      ),
      mission: {
        title: "مهمتنا",
        description: sentence(
          "مساعدة مختبري البرمجيات على التكيف مع تغيرات السوق وتطوير خبراتهم من خلال",
          "التعلم الموثوق والإرشاد والمجتمع. كما نساعد الشركات على العثور على أفضل",
          "مواهب QA وتحسين تجربة فرقها، مع تقديم خدمات اختبار احترافية.",
        ),
      },
      vision: {
        title: "رؤيتنا",
        description: sentence(
          "أن نصبح المنصة الرائدة في منطقة الشرق الأوسط وشمال أفريقيا وعالميًا حيث",
          "يتعلم مختبري البرمجيات وينمون ويكسبون — والشريك الموثوق للشركات التي تبني",
          "فرق QA استثنائية.",
        ),
      },
    },
    values: {
      label: "القيم",
      title: "ما الذي يدفعنا",
      subtitle: "هذه المبادئ تشكل كل قرار وميزة ومحادثة داخل Quality Nexus.",
      growth: {
        title: "عقلية النمو",
        description: sentence(
          "كل مختبر يمكنه الاستمرار في التطور. نؤمن بالتعلم، والتغذية الراجعة الصادقة،",
          "واعتماد الأدوات والمتطلبات التي تشكل عمل QA في المستقبل.",
        ),
      },
      community: {
        title: "المجتمع أولاً",
        description: sentence(
          "نرتقي بمشاركة المعرفة، وتقديم التغذية الراجعة الصادقة، والاحتفال بالإنجازات،",
          "ودعم بعضنا البعض خلال تغيرات صناعتنا.",
        ),
      },
      innovation: {
        title: "التعلم المستمر",
        description: sentence(
          "نبقى فضوليين تجاه الأساليب الجديدة والذكاء الاصطناعي والتقنيات التي تبقي",
          "المختبرين والفرق في طليعة مجال سريع الحركة.",
        ),
      },
      quality: {
        title: "النزاهة والثقة",
        description: "نحن صرحاء وشفافون وملتزمون بكسب ثقة أعضائنا وشركائنا والشركات التي نخدمها.",
      },
    },
    timeline: {
      label: "رحلتنا",
      title: "كيف ولد Quality Nexus",
      subtitle: "بعض المحطات التي تُميز نمو مجتمعنا ومنصتنا.",
      late2024: {
        year: "نهاية 2024",
        title: " الشرارة",
        description: sentence(
          "خلال خروجة عفوية، ناقش مجموعة من أصدقاء QA كيف يشعر المبتدئون وال juniors",
          "بالضياع في عالم الاختبار. بحلول نهاية المحادثة، كانت فكرة Quality Nexus قد",
          "ولدت.",
        ),
      },
      "2025_announce": {
        year: "2025",
        title: "شاركنا الرؤية",
        description: sentence(
          "قدّمنا Quality Nexus لمجتمع QA الأوسع، مدعوين المختبرين والشركات للانضمام",
          "إلى منصة بُنيت حول التعلم والربح والنمو الحقيقي.",
        ),
      },
      "2025_meetups": {
        year: "2025",
        title: "بدأت اللقاءات",
        description: sentence(
          "بدأنا في تنظيم لقاءات ودراسات محلية لربط المختبرين ببعضهم، ومشاركة المعرفة،",
          "وبناء ثقافة من الدعم الحقيقي.",
        ),
      },
      "2025_services": {
        year: "2025",
        title: "إطلاق خدمات الاختبار",
        description: sentence(
          "بدأنا في تقديم خدمات اختبار احترافية للشركات، مساعدة إياها على إطلاق منتجات",
          "أفضل دون الحاجة لتوظيف فرق QA كبيرة من اليوم الأول.",
        ),
      },
      "2025_blog": {
        year: "2025",
        title: "إطلاق المدونة التقنية",
        description: sentence(
          "أطلقنا مدونتنا لتشارك أدلة QA عملية، ورؤى واقعية من الاختبار، ومواد تعليمية",
          "موثوقة للمجتمع.",
        ),
      },
      late2025_platform: {
        year: "نهاية 2025",
        title: "العمل على المنصة",
        description: sentence(
          "في نهاية 2025 بدأنا في بناء منصة Quality Nexus لتوسيع نطاق الإرشاد والتعلم",
          "وفرص العمل والاختبار الجماعي.",
        ),
      },
      soon_community: {
        year: "قريبًا",
        title: "إطلاق منصة المجتمع",
        description: sentence(
          "إطلاق منصة Quality Nexus المجتمعية الكاملة التي يمكن للمختبرين من خلالها",
          "التواصل والتعلم ومشاركة المعرفة والنمو معًا.",
        ),
      },
      soon_company: {
        year: "قريبًا",
        title: "تسجيل الشركات",
        description: sentence(
          "إتاحة ملفات شركات مخصصة تتيح لها التواصل مباشرة مع محترفي الجودة، وعرض",
          "فرقها، ونشر فرص عمل QA أمام تجمع المواهب المناسب.",
        ),
      },
      soon_crowd: {
        year: "قريبًا",
        title: "منصة الاختبار الجماعي",
        description: sentence(
          "إطلاق منصة اختبار جماعي تتيح للشركات تسجيل مشاريعها وتنفيذ حملات اختبار",
          "واقعية مع مختبري المجتمع الموثوقين.",
        ),
      },
    },
    cta: {
      title: "مستعد لتنمية مسيرتك المهنية أو فريق QA معنا؟",
      subtitle: sentence(
        "انضم إلى آلاف مختبري البرمجيات وفرق QA الذين يبنون مسارات مهنية أفضل،",
        "ومنتجات أفضل، ومجتمع أقوى معًا.",
      ),
      primaryCta: "انضم إلى المجتمع",
      secondaryCta: "استكشف الخدمات",
    },
  },
};
